<template lang="pug">
Row.col-layout
  Column(tablet="5")
    .rogue-hide(v-if="renderTranslations")
      .text(v-html="page.content" v-translate v-for="page in pages.filter(p => p.content)")
    .text(v-html="__(text, 'auto')")
  Column.images(tablet="7")
    .white-gradient
    Carousel(@change="imageSlide = $event" :snap="true")
      StaticImage.img(
        v-for="image in images"
        :key="image.textPage"
        :src="image.image.src",
        :alt="image.image.alt || ''"
        :width="474"
        :height="308"
        :img-width="image.image.width"
      )
</template>
<script setup lang="ts">
import { computed, ref, useSSRContext } from 'vue'
import { useRogue } from '../../js/rogue'

type Image = {
  src?: string,
  width?: number,
  height?: number,
}

type Page = {
  content?: string,
  images?: Image[],
  image?: Image
}

const props = withDefaults(defineProps<{
  pages: Page[]
}>(), {
  pages: () => ([]),
})

const imageSlide = ref(0)
const renderTranslations = ref(false)

const images = computed<{textSlide: number, image: Image}[]>(() => {
  return props.pages
    .map((p, textSlide) => (p.images ? p.images : [p.image])
      .map(image => ({ textSlide, image: { ...image, height: 308 } }))).flat()
})

const text = computed(() => {
  const textPage = props.pages[images.value[imageSlide.value]?.textSlide] || props.pages[0]

  return textPage?.content || ''
})

const rogue = useRogue()

if (rogue?.ssr) {
  const ssrContext = useSSRContext()
  renderTranslations.value = ssrContext?.queryParams?.SAVE_TRANSLATIONS
}
</script>
<style lang="scss" scoped>
.images {
  position: relative;
}

.img {
  width: 474px;
  height: 308px;
  margin-right: $space-l;
}

.white-gradient {
  position: absolute;
  z-index: 1;
  right: 0;
  width: 104px;
  height: 100%;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.59) 100%);
  border-radius: 0px;
}
</style>
